import React from "react";
import { useLocalization } from "./LocalizationProvider";
export default function MenuText({ children }) {
    const { menuText } = useLocalization();
    return <>{menuText(children)}</>;
}
